
<template>


    <v-container>
    
 
  <v-row style="font-size: 22px; color:darkorange">
<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;傳送資料至戶外顯示板
</v-row>

        
        <!--v-combobox
        v-model="areaId"
        label="存取區域"
        :items="itemAreas"
        item-title="text"
        item-value="value"
        variant="solo"
        class="pa-1"
        style="width: 300px;"
        return-object
    ></v-combobox>
        <v-combobox
                v-model="controlId"
                label="控制項目"
                :items="itemControls"
                item-title="text"
                item-value="value"
                style="width: 300px;"
                
              ></v-combobox>
        <v-btn 
                @click="fetchData" 
                class="load-button"
                color="#5865f2"
                size="medium"
                variant="flat" >載入表格及資料
        </v-btn>
        <br/-->
        <br/>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="Id"
        class="elevation-1"
        height="350"
        fixed-header
        items-per-page-text="每頁顯示筆數"
        no-data-text="無資料"
        loading-text="載入中"
        :pageText="'{0}-{1} 之 {2}'"
        @click:row="(item,row) => rowClick(item,row)" 
        :item-class="() => 'getRowClass'"
        items-per-page="5"
        single-select
      >
      <template v-slot:[`item.send`]="{ item }">
        <v-icon 
          @click="SendData2Dashboard(item)"
          color="red"
          @click.prevent
        >
        mdi-play
      </v-icon>
    </template>
       
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios';
  import {reactive, toRefs,onBeforeMount,onMounted,ref,watch} from 'vue'
  import vuetify from '../plugins/vuetify';
  const env = import.meta.env;
  const apiUrl = window.config.API_URL; //(env.VITE_APP_API_ENDPOINT);
  

  export default {
    mounted() {
      //this.fetchFormFields(); 
      //this.loadData();
      this.loadData();
      
    },
    data() {
        console.log('api url',this.$config.API_URL);
      return {
        apiUrl: this.$config.API_URL,
        userId:null,
        userName:null,
        control:null,
        dialog: false,
        itemAreas:[],
        itemControls:[],
        selectedRows: [],
        headers: [
          { title: '模版名稱', key: 'templateName', type:0 },
          { title: '模版內容', key: 'templateLayout', type:0},
          { title: '寬 X 長', key: 'size' ,type:0},
          { title: '傳送', key: 'send', type:-1, sortable: false }
          //{ title: 'PHONE', key: 'phone' },
          //{ title: 'Actions', key: 'actions', sortable: false }
        ],
        items: [],
        editedIndex: -1,
        
        defaultItem: {
          templateName: '',
          templateLayout: '',
          size: '',
          
        },
        
      };
    },
    
   
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? '新增項目' : '編輯項目';
      }
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      }
    },
    methods: {
        SendData2Dashboard(item)
        {
            alert('傳送 ['+item.templateName+'] 至看板');
        },
        getSelectedValue(key)
        {
          //alert(key);
          console.log('key 0',key);
          switch(key) {
            case 'areas':
              console.log('selected A',this.item.areasDisplay);
            return this.item.areasDisplay;
            case 'controls':
            console.log('selected C',this.item.controlsDisplay);
            return this.item.controlsDisplay;
            default:
            return [];
        }
        },
        
        async loadData()
        {
            try {
                
                
                //console.log('api:'+ `${apiUrl}/item/getaccessitems`);
                const response = await axios.get(`${apiUrl}/template/getTemplatesEx`);
                //console.log(response);
                console.log(response.data);
                
                this.items=response.data;
                console.log('[items]',this.items);
                //console.log(this.itemControls);
                //let d=new Date();
                //d.setHours(d.getHours() + 8)
                //this.formData['formDate']=d.toISOString().substr(0, 10);

                
            } catch (error) {
                console.error('載入站台及類型錯誤:', error);
                alert('載入資料錯誤:'+ error);
            }
        },
        async loadFormAndData()
        {
            try
            {

            }
            catch(e)
            {
                
            }
        },
      async fetchData() {
        try {
            console.log('call fetchData',`${apiUrl}/item/getUserItems`);
          const response = await axios.get(`${apiUrl}/item/getUserItems`)
          .then(response => {
    console.log('Response Data:', response.data); // Log the entire response data

    this.items = response.data.map(user => {
        console.log(user.areaIds);
      const areaIds = user.areaIds ? user.areaIds.split(',') : '';
      const controlIds = user.controlIds ? user.controlIds.split(',') : '';

      console.log('User:', user);
      console.log('AreaIds:', areaIds);
      console.log('ControlIds:', controlIds);

      var selected=areaIds;
      console.log('selected ',selected);
      const selectedAreas = this.itemAreas.filter(area => areaIds.includes(area.areaId));

      const selectedControls = this.itemControls.filter(control => controlIds.includes(control.controlId));
      return {
        ...user,
       
        selectedAreas,
        selectedControls,
      };
    });
  })
  .catch(error => {
    console.error('Error fetching data:', error);
  });


        } catch (error) {
          console.error(error);
        }
      },
      
      closeDialog() {
        this.dialog = false;
        
      },
      
      getRowClass(item) {
        console.log('getRowClass');
        console.log('item',item);
        return this.selectedRows.includes(item.id) ? 'selected-row' : '';
      },
      rowClick: function (item, row ) {      
        console.log('row',row);
        //console.log('item',item.value);
        //return;
        const id = row.item.itemName // just temporary
        console.log('item',row.item.itemName);
        const rowNo = this.selectedRows.indexOf(id)
        if(rowNo == -1) {
          this.selectedRows.push(id)
          //row.select(true);
        } else {
          this.selectedRows.splice(rowNo, 1)
          ///row.select(false);
        }
        console.log(this.selectedRows)
      },
      log: function (event) {      
        console.log(event)
      }
    },
    created() {
      //this.fetchData();
    }
  };
  </script>
  
  <style scoped>
  .label-container {
    display: inline-block;
    margin-left: 15px;
    vertical-align: top;
  }
  
  .field-container {
    display: inline-flex;
    flex-wrap: wrap;
    margin-left: 10px;
  }
  
  .text-field-wrapper {
    flex: 1;
    min-width: 100px;
    margin-right: 10px;
  }
  
  @media (max-width: 600px) {
    .text-field-wrapper {
      flex: 0 1 45%;
      margin-bottom: 10px;
    }
  }
  .selected-row {
  background-color: #e0f7fa; /* Change to your desired color */
}
tr.v-data-table__selected {
  background: #7d92f5 !important;
}
  </style>
  